/**
 * Login-history telemetry: which device and browser an operator signed in from.
 *
 * 🔴 THERE IS NO IP LOOKUP HERE, AND THERE MUST NOT BE ONE AGAIN.
 *
 * This used to `fetch("https://api.ipify.org")` to learn the console's own
 * public IP, because `POST /login-history` took `ipAddress` from the request
 * body. Both halves of that were wrong:
 *
 *  - A browser cannot know its own public IP without asking a third party, and
 *    `api.ipify.org` is not in this console's `connect-src` — deliberately, since
 *    the point of that directive is to stop the browser calling off-host
 *    origins. So the lookup failed for every operator on every page load. Ad
 *    blockers and corporate proxies block it too.
 *  - The IP was then whatever the client said it was, inside a security-audit
 *    record. The API now reads it off the connection (`req.ip`, resolved against
 *    the trust-proxy list), which is both correct and unspoofable.
 *
 * An earlier attempt kept the fetch and degraded the failure to `ipAddress: ""`.
 * That changed nothing at the server: mongoose enforces `required` on a String
 * as `length > 0`, so `""` threw the same `Path ipAddress is required` that
 * `undefined` did, and every operator got two error toasts a page load while no
 * login-history row was written for anyone. The lookup is gone instead.
 */
const DeviceDetails = () => {
  const userAgent = navigator.userAgent;

  const device = /Mobi|Android/i.test(userAgent)
    ? "Mobile"
    : /Tablet|iPad/i.test(userAgent)
      ? "Tablet"
      : "Desktop/Laptop";

  const browser = (() => {
    if (userAgent.includes("Chrome")) return "Chrome";
    if (userAgent.includes("Firefox")) return "Firefox";
    if (userAgent.includes("Safari")) return "Safari";
    if (userAgent.includes("Edge")) return "Edge";
    return "Unknown Browser";
  })();

  return {
    device,
    browser,
  };
};

export default DeviceDetails;
